import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqData = [
  {
    question: 'How do I book an appointment?',
    answer: 'You can book by calling us at 01637 498050, messaging us on Facebook, or emailing us at studio@atlanticcoasttattoo.com. Please include details about your design, size, placement, and preferred dates. We schedule appointments up to three months in advance.'
  },
  {
    question: 'How old do I have to be to get a tattoo?',
    answer: 'You must be at least 18 years of age. It is against UK law to tattoo a minor, even with parental consent. We have a strict No Minors policy. Every client must prove their age with a valid Photo ID. No exceptions.'
  },
  {
    question: 'How much does a tattoo cost?',
    answer: 'Pricing depends on the artist, size, detail, and placement of the design. The best way to get an accurate price range is by booking a consultation with your chosen artist. Smaller tattoos are priced individually, while larger projects are charged by the hour or as a full-day session.'
  },
  {
    question: 'How can I get a price quote?',
    answer: 'The best way to get an accurate price range is by booking a free consultation with the artist of your choosing, either in person or through email. We also offer virtual consultations via video call. You are always welcome to come into the shop and talk to one of our artists!'
  },
  {
    question: 'Do you accept walk-ins?',
    answer: 'Yes! Walk-in appointments are available daily on a first-come, first-served basis. The best way to explore availability is to call us or message us on Facebook. If you want to get tattooed, we can make it happen!'
  },
  {
    question: 'Does it hurt?',
    answer: 'Yes! But in the best possible way. Your brain releases endorphins when you go through pain and your body loves endorphins, so yes, it hurts, but you\'ll kind of like it.'
  },
  {
    question: 'How long does a tattoo take to heal?',
    answer: 'It takes two to three weeks to "heal," but it takes months for the skin to fully regenerate. You will be given detailed aftercare instructions after your tattoo.'
  },
  {
    question: 'How should I prepare for my tattoo?',
    answer: 'Eat well before you come in and stay hydrated. If you start to feel woozy, have a soda — sugar is your friend. Avoid alcohol the night before as it can increase bleeding. Remember to stay calm, you\'re in good hands!'
  },
  {
    question: 'What forms of payment are accepted?',
    answer: 'We accept cash and credit cards (Visa, Mastercard, Discover, American Express). No checks.'
  },
  {
    question: 'Do I need to leave a deposit?',
    answer: 'Yes. A 25% deposit is required to make an appointment. Deposits are non-refundable and non-transferable and will be applied to the final price or last session of your tattoo.'
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="relative py-20 bg-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-display text-4xl md:text-6xl font-bold text-white mb-4">
            FAQ
          </h2>
          <p className="text-white/70 tracking-wider">FREQUENTLY ASKED QUESTIONS</p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={faq.question}
              className="border-b border-white/20 pb-4"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center text-left py-4 hover:opacity-70 transition-opacity"
              >
                <h3 className="text-white text-lg font-medium pr-8">
                  {faq.question}
                </h3>
                <span className="text-white flex-shrink-0">
                  {openIndex === index ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                </span>
              </button>
              {openIndex === index && (
                <div className="pb-4 text-white/70 leading-relaxed animate-fade-in">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;